import React from "react";
import styles from "./VisaInfoSection.module.css";

function VisaInfoSection() {
  return (
    <>

     {/* WHY CHOOSE US */}
      <div className={styles.whyChooseSection}>
        <h2>Why Choose Atlas Travel House?</h2>

        <div className={styles.whyChooseGrid}>
          <div className={styles.whyCard}>
            <span>100000+</span>

            <h3>Visa Applications Assisted</h3>

            <p>
              Trusted support for tourist, business, student, and
              multiple-entry visas.
            </p>
          </div>

          <div className={styles.whyCard}>
            <span>50+</span>

            <h3>Global Destinations</h3>

            <p>
              Visa assistance for major travel destinations across the world.
            </p>
          </div>

          <div className={styles.whyCard}>
            <span>Fast</span>

            <h3>Documentation Support</h3>

            <p>
              Professional guidance for documentation, eligibility, and
              application processes.
            </p>
          </div>

          <div className={styles.whyCard}>
            <span>Trusted</span>

            <h3>Travel Experts</h3>

            <p>
              Reliable visa assistance backed by experienced travel
              professionals.
            </p>
          </div>
        </div>
      </div>
      {/* IMPORTANT INFO SECTION */}
 <div className={styles.visaInfoSection}>
  <h2>Essential Visa Guidelines</h2>

  <div className={styles.visaInfoBox}>
    <ul>
      <li>
        Visa fees and service charges are subject to change depending on
        embassy, VFS center, consulate, and country-specific regulations.
      </li>

      <li>
        Visa processing duration may vary depending on embassy approval,
        application volume, nationality, and travel history.
      </li>

      <li>
        Standard processing timelines are approximate and do not guarantee
        visa issuance within a fixed period.
      </li>

      <li>
        Applicants are advised to apply well in advance of their planned
        travel date to avoid delays.
      </li>

      <li>
        Commonly required documents may include passport, photographs,
        bank statements, ITR, hotel bookings, flight reservations,
        cover letter, and employment or business proof.
      </li>

      <li>
        Additional documents may be requested by the embassy or immigration
        authorities during the application process.
      </li>

      <li>
        Visa approval or rejection is solely at the discretion of the
        respective embassy or consulate.
      </li>

      <li>
        Submission of complete and accurate documents improves the chances
        of smooth visa processing.
      </li>

      <li>
        Applicants must ensure that their passport has sufficient validity
        and blank pages as per destination requirements.
      </li>

      <li>
        Interview, biometric appointment, or physical appearance may be
        mandatory for certain countries and visa categories.
      </li>

      <li>
        Travel insurance may be mandatory for selected destinations,
        especially Schengen countries.
      </li>

      <li>
        Visa fees, appointment charges, courier fees, and insurance charges
        are generally non-refundable once processed.
      </li>

      <li>
        Processing timelines may increase during peak travel seasons,
        holidays, or embassy closures.
      </li>

      <li>
        Previous visa refusals, overstays, or immigration violations may
        affect future visa applications.
      </li>

      <li>
        Atlas Travel House provides assistance and guidance for visa
        applications but does not guarantee visa approval.
      </li>

      <li>
        Applicants are responsible for verifying the latest travel
        advisories, transit requirements, and entry restrictions before
        departure.
      </li>
    </ul>
  </div>
</div>

     
    </>
  );
}

export default VisaInfoSection;